import { render } from "./NeedsApproval.vue?vue&type=template&id=cffb48ec&scoped=true&ts=true"
import script from "./NeedsApproval.vue?vue&type=script&lang=ts"
export * from "./NeedsApproval.vue?vue&type=script&lang=ts"

import "./NeedsApproval.vue?vue&type=style&index=0&id=cffb48ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cffb48ec"]])

export default __exports__